import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { withTranslation, Trans } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import styles from '../../assets/jss/confirmPopupStyles';

function CPopup(props) {
  const {
    classes,
    modalContent,
    openDialouge,
    modalDismiss,
    icon,
    icons,
    modalSubmit,
  } = props;

  return (
    <Dialog
      open={openDialouge}
      onClose={modalDismiss}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle className={classes.dialogTitle}>
        {icon
          ? <span className={classes.moduleImage}>{icon || icons}</span> : null}
        <Trans i18nKey={modalContent.title} />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <h4>
          <Trans i18nKey={modalContent.body} />
          {' '}
          {modalContent.status ? ` '${modalContent.status}' ` : ''}
          {modalContent.name ? ` '${modalContent.name}' ?` : ''}
        </h4>
        {modalContent.content ? (
          <h4>
            {modalContent.content}
          </h4>
        ) : null}
      </DialogContent>

      <DialogActions className={`${classes.dialogAction} ${classes.removePosition}`}>
        {modalContent.title !== 'VULNERABILITY.STR' && (
          <Button className={classes.activeButton} onClick={modalSubmit}>
            <Trans>BUTTON.OK</Trans>
          </Button>
        )}
        <Button
          className={`${classes.defaultButton} ${classes.changeBg}`}
          onClick={modalDismiss}
        >
          <Trans>BUTTON.ABORT</Trans>
        </Button>
      </DialogActions>

    </Dialog>
  );
}

CPopup.defaultProps = {
  confirmModal: true,
};
export default withTranslation()(withStyles(styles, { withTheme: true })(CPopup));
